import type { ReactNode } from 'react'

import { Divider, Header, Space, Spacer, Text } from '@procurify/ui'

import { BillItemPopoverLayoutStyled } from './BillItemPopoverLayoutStyled'

interface BillItemPopoverRow {
  id: string
  label: string
  valueComponent: ReactNode
}

interface BillItemPopoverLayoutProps {
  title?: string
  badge?: ReactNode
  description?: ReactNode
  bodyRows?: BillItemPopoverRow[]
  footerRows?: BillItemPopoverRow[]
}

const BillItemPopoverLayoutRow = ({
  id,
  label,
  valueComponent,
}: BillItemPopoverRow) => {
  return (
    <Space direction='horizontal' align='center' justify='space-between'>
      <Text bold id={id}>
        {label}
      </Text>
      <span aria-labelledby={id}>{valueComponent}</span>
    </Space>
  )
}
export const BillItemPopoverLayout = ({
  title,
  badge,
  description,
  bodyRows,
  footerRows,
}: BillItemPopoverLayoutProps) => {
  return (
    <BillItemPopoverLayoutStyled>
      <Header as='h5'>{title}</Header>
      {badge && (
        <>
          <Spacer space={1} />
          {badge}
        </>
      )}
      {description && (
        <>
          <Spacer space={1} />
          {description}
        </>
      )}
      <Spacer space={1.3} />
      <Space direction='vertical' size='small'>
        {bodyRows?.map((row, index) => (
          <BillItemPopoverLayoutRow
            key={`${row.label}-${index}`}
            id={row.id}
            label={row.label}
            valueComponent={row.valueComponent}
          />
        ))}
      </Space>
      {footerRows && footerRows.length !== 0 && (
        <>
          <Divider />
          <Space direction='vertical' size='small'>
            {footerRows.map((row, index) => (
              <BillItemPopoverLayoutRow
                key={`${row.label}-${index}`}
                id={row.id}
                label={row.label}
                valueComponent={row.valueComponent}
              />
            ))}
          </Space>
        </>
      )}
    </BillItemPopoverLayoutStyled>
  )
}
